import { useState } from "react";
import SubHeader from "../../../components/SubHeader";
import PostalCodeImport from "./PostalCodeImport";
import ConfirmModal from "@/components/ConfirmModal";
import {useAdminAuthCheck} from "@/containers/admin/useAdminAuthCheck";
import * as Config from "@/config";
import { useProjectStore } from "@/stores/project";

export default function PostalCodeManagement() {
  useAdminAuthCheck(Config.RESTRICTION_HISTORY_POSTAL_CODE_MANAGEMENT);
  const [
    selectedProject,
    selectedAdminCategory,
  ] = useProjectStore(state => [
    state.project,
    state.adminCategory,
  ]);

  const [modalMessage, setModalMessage] = useState<{
    type: {};
    message: string;
  } | null>(null);

  const breadCrumbs = [
    { title: selectedProject?.name },
    { title: selectedAdminCategory?.name },
  ];

  return (
    <div>
      <div className="sub-header">
        <SubHeader breadCrumbs={breadCrumbs} title={selectedAdminCategory?.name} />
      </div>
      <div className="container">
        <PostalCodeImport />
      </div>
      <ConfirmModal
        text={modalMessage?.message ?? ""}
        confirmButtonText="OK"
        isShow={!!modalMessage?.message}
        onConfirm={() => setModalMessage(null)}
      />
    </div>
  );
}
